import _slicedToArray from "/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useReducer, useEffect } from 'react';

var getStateClasses = function getStateClasses(fieldStates, fieldName) {
  var loadingClass = fieldStates.isLoading ? "field-loading" : "";
  var activeClass = fieldStates.isActive ? "field-active" : "field-inactive";
  var errorClass = fieldStates.withError ? "with-error ".concat(fieldName, "-with-error") : "without-error ".concat(fieldName, "-without-error");
  var contentClass = fieldStates.withContent ? 'with-content' : 'without-content';
  var disabledClass = fieldStates.isDisabled ? 'field-disabled' : 'field-enabled';
  return "".concat(contentClass, " ").concat(activeClass, " ").concat(loadingClass, " ").concat(disabledClass, " ").concat(errorClass);
};

var changeState = function changeState(states, name, errors, typeValidation, dataValidation) {
  switch (typeValidation) {
    case 'value':
      states.withContent = dataValidation && dataValidation.value;
      break;

    case 'input-value':
      states.withContent = dataValidation && dataValidation.inputValue;
      break;

    case 'active':
      states.isActive = dataValidation;
      break;

    case 'loading':
      states.isLoading = dataValidation;
      break;

    case 'disabled':
      states.isDisabled = dataValidation;
      break;

    default:
      break;
  }

  states.withError = Boolean(errors && errors[name]);
  return states;
};

var initialFieldValidationSate = {
  classes: '',
  fieldStates: {
    withError: false,
    withContent: false,
    isActive: false,
    isDisabled: false,
    isLoading: false
  },
  rules: {},
  errors: {},
  value: '',
  inputValue: '',
  name: ''
};

var FieldValidationReducer = function FieldValidationReducer(state, action) {
  switch (action.type) {
    case 'state-error':
      return Object.assign(Object.assign({}, state), {
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, null, null))
      });

    case 'rules':
      return Object.assign(Object.assign({}, state), {
        rules: action.validationRules
      });

    case 'errors':
      return Object.assign(Object.assign({}, state), {
        errors: action.validationErrors,
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, null, null))
      });

    case 'name':
      return Object.assign(Object.assign({}, state), {
        name: action.fieldName
      });

    case 'value':
      return Object.assign(Object.assign({}, state), {
        value: action.fieldValue,
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'value', action.fieldValue))
      });

    case 'input-value':
      return Object.assign(Object.assign({}, state), {
        inputValue: action.fieldValue,
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'inputValue', action.fieldValue))
      });

    case 'state-active':
      return Object.assign(Object.assign({}, state), {
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'active', action.state))
      });

    case 'state-disabled':
      return Object.assign(Object.assign({}, state), {
        fieldStates: Object.assign({}, changeState(state.fieldStates, state.name, state.errors, 'disabled', action.state))
      });

    case 'get-classes':
      return Object.assign(Object.assign({}, state), {
        classes: getStateClasses(action.states, action.name)
      });

    default:
      return state;
  }
};

export var useFieldValidation = function useFieldValidation(validations, errors, name, disabled) {
  var _useReducer = useReducer(FieldValidationReducer, initialFieldValidationSate),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(function () {
    dispatch({
      type: 'rules',
      validationRules: validations
    });
    dispatch({
      type: 'name',
      fieldName: name
    });
    dispatch({
      type: 'state-disabled',
      state: disabled
    });
  }, [validations, name, disabled]);
  useEffect(function () {
    dispatch({
      type: 'errors',
      validationErrors: errors
    });
  }, [errors]);
  useEffect(function () {
    dispatch({
      type: 'get-classes',
      states: state.fieldStates,
      name: name
    });
  }, [state.fieldStates]);
  useEffect(function () {
    dispatch({
      type: 'state-error'
    });
  }, [state.errors]);

  var setValue = function setValue(value) {
    dispatch({
      type: 'value',
      fieldValue: value
    });
  };

  var setInputValue = function setInputValue(option) {
    dispatch({
      type: 'input-value',
      fieldValue: option === null || option === void 0 ? void 0 : option.value
    });
  };

  var setActive = function setActive(a) {
    dispatch({
      type: 'state-active',
      state: a
    });
  };

  return Object.assign(Object.assign({}, state), {
    setValue: setValue,
    setInputValue: setInputValue,
    setActive: setActive
  });
};